import { render, staticRenderFns } from "./product-dynamic-filter.vue?vue&type=template&id=0d7704b1&lang=pug"
import script from "./product-dynamic-filter.vue?vue&type=script&lang=js"
export * from "./product-dynamic-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports